import { FetchExperimentsRequestTypes } from '../actions/ExperimentationActions';
import { EXPERIMENTATION_SET_ELIGIBILITY } from '../actions/constants/ActionTypes';
const INITIAL_STATE = {
  treatments: {},
  eligibleTreatments: []
};
const Experimentation = (state = INITIAL_STATE, {
  type,
  payload
}) => {
  switch (type) {
    case FetchExperimentsRequestTypes.RECEIVE:
      {
        return Object.assign({}, state, {
          treatments: payload
        });
      }
    case EXPERIMENTATION_SET_ELIGIBILITY:
      {
        if (!payload.isEligible) {
          return state;
        }
        return Object.assign({}, state, {
          eligibleTreatments: [...state.eligibleTreatments.filter(treatment => treatment.treatmentKey !== payload.treatmentKey), payload]
        });
      }
    default:
      return state;
  }
};
export default Experimentation;